import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Form, Input, Typography, message, Checkbox } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { FcGoogle } from "react-icons/fc";
import { BsTwitterX } from "react-icons/bs";
import { FaFacebookF, FaApple } from "react-icons/fa";
import './styles.scss'
import { mixGetV1, mixPostV1 } from 'services/mixin'
import { GoogleLogin } from './LoginByGG';
import { API_URL } from 'env';

const LoginPage = () => {
  const [form] = Form.useForm();
  const [status, setStatus] = React.useState<'idle' | 'loading' | 'error'>('idle');

  const onFinish = async (values: any) => {
    setStatus('loading');
    try {
      const res = await fetch(`${API_URL}/api/v1/be/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });
      const data = await res.json();
      console.log('Login response:', data);

      if (data.status) {
        localStorage.setItem('token', data.data.access_token);
        // localStorage.setItem('user', JSON.stringify(data.data.info));
        const res2 = await mixGetV1(`/api/v1/be/user/${data.data.info.id}`)

        if (res2.status) {
          localStorage.setItem('user', JSON.stringify(res2.data))

          message.success('Login successful!');
          window.location.href = '/accounts-overview';
        }

        // message.success('Login successful!');
        window.location.href = '/accounts-overview'; // Redirect to accounts overview page
        return;
      }
      else if (data.status === false && data.error && data.error.needs_verification) {
        const resOtp = await mixPostV1('/api/v1/request-verification', {
          email: values.email,
          password: values.password,
        });
        if (resOtp.status) {
          message.success('Verification code sent to your email. Please check your inbox.');
        } else {
          message.error(resOtp.message || 'Failed to send verification code, please try again!');
          return;
        }
        window.location.href = `/verify-otp?uid=${data.error.user_id}&reactive=true`;

      } else if (data.status === false && data.error && data.error.password_wrong) {
        message.error('Incorrect password, please try again!');
        return;
      }
      else {
        message.error('Login failed, please try again!');
        return;
      }
    }
    catch (error) {
      console.error('Login error:', error);
    }
    finally {
      setStatus('idle');
    }
  };

  const handleLoginGoogle = async () => {
    const res = await mixGetV1(`/api/v1/google/auth-url?redirect_uri=https://44c717e01e12.ngrok-free.app`)

    if (res.status) {
      window.location.href = res.data.auth_url;
    }
  }

  const handleLoginFacebook = async () => {
    // logic login here
    return;
  };
  const handleLoginTwitter = async () => {
    // logic login here
    return;
  };
  const handleLoginApple = async () => {
    // logic login here
    return;
  };
  return (
    <div className="form-signup">
      {/* <Typography.Title level={2} className="text-center text-gray-800 mb-6">
          ĐĂNG NHẬP
        </Typography.Title> */}
      <Form
        form={form}
        name="login_form"
        onFinish={onFinish}
        layout="vertical"
        initialValues={{ remember: true }}
        size='large'
      >
        <Form.Item
          name="email"
          // label='Email'
          rules={[{ required: true, message: 'Email is required!' }]}
        >
          <Input
            prefix={<MailOutlined className="!text-white/90" />}
            placeholder="Enter your email address"
            className="custom-input !rounded-full !bg-transparent !text-white"
            disabled={status === 'loading'}
          />
        </Form.Item>

        <Form.Item
          name="password"
          // label='Password'
          rules={[{ required: true, message: 'Password is required!' }]}
        >
          <Input.Password
            prefix={<LockOutlined className="!text-white/90" />}
            placeholder="Enter your password"
            className="custom-input !text-white/90 !rounded-full !bg-transparent"
            disabled={status === 'loading'}
          />
        </Form.Item>

        <div className='remember-forgot'>
          <Checkbox className='text-white font-semibold'>Remember me</Checkbox>
          <Link to='/forget-password' className='text-white font-semibold'>Forgot password?</Link>
        </div>

        <Form.Item>
          <Button
            disabled={status === 'loading'}
            type="primary" htmlType="submit" block className="btn-submit !bg-white hover:!bg-white/80 !text-black !text-[18px] !rounded-full !h-10">
            Login
          </Button>
        </Form.Item>

        {/* <div className='link-box'>
              <Link to='/sign-up'>Đăng ký</Link>
          </div> */}

      </Form>
      <div className="flex items-center mb-4">
        <div className="flex-grow border-t border-gray-300"></div>
        <span className="mx-2 text-white text-sm">or</span>
        <div className="flex-grow border-t border-gray-300"></div>
      </div>
      <div className='flex flex-col md:flex-row gap-2 mb-2'>
        {/* <button
          type="button"
          onClick={handleLoginGoogle}
          className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
        >
          <FcGoogle className="w-5 h-5" />
          Continue with Google
        </button> */}
        <GoogleLogin />
        {/* <button
          type="button"
          onClick={handleLoginTwitter}
          className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
        >
          <BsTwitterX className="w-5 h-5" />
          Continue with X
        </button> */}
      </div>

      {/* <div className='flex flex-col md:flex-row gap-2 mb-4'>
        <button
          type="button"
          onClick={handleLoginFacebook}
          className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
        >
          <FaFacebookF className="w-4 h-4 text-blue-600" />
          Continue with Meta
        </button>
        <button
          type="button"
          onClick={handleLoginApple}
          className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-2 px-4 !rounded-sm hover:!bg-white/60 transition duration-300 flex items-center justify-center gap-2"
        >
          <FaApple className="w-5 h-5" />
          Continue with Apple
        </button>
      </div> */}
    </div>

    // <div className="Login-page">
    // </div>
  );
};

export default LoginPage;
